var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list",
    [
      _c(
        "w-list-item",
        [
          _c("w-list-item-text", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.$ct("restrict-to-ip-addresses")) + " "),
          ]),
        ],
        1
      ),
      _vm.user.RestrictedToIPAddresses.length == 0
        ? _c(
            "w-list-item",
            [
              _c("w-list-item-text", { staticClass: "note" }, [
                _vm._v(
                  " " + _vm._s(_vm.$ct("no-ip-restriction-added-yet")) + " "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.user.RestrictedToIPAddresses, function (ip, i) {
        return _c(
          "w-list-item",
          { key: i },
          [
            _c(
              "w-list-item-text",
              [
                _c("w-input", {
                  attrs: {
                    "has-error": !_vm.isIpValid(ip),
                    placeholder: _vm.$ct("ip-address"),
                  },
                  model: {
                    value: _vm.user.RestrictedToIPAddresses[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.user.RestrictedToIPAddresses, i, $$v)
                    },
                    expression: "user.RestrictedToIPAddresses[i]",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("remove-ip"),
                        expression: "$ct('remove-ip')",
                      },
                    ],
                    staticClass: "danger",
                    staticStyle: { height: "100%" },
                    on: {
                      click: function ($event) {
                        return _vm.removeIp(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.addIp()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-ip-address")))]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }